import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router';
import redraft, { createStylesRenderer, createBlockRenderer } from 'redraft';
import { ContentBlock } from 'draft-js';

const createContentBlock = block => new ContentBlock(block);
const styles = {};

const addBreaklines = children => children.map(child => [child, <br />]);

const renderers = {
  inline: {
    BOLD: (children, { key }) => <strong key={key}>{children}</strong>,
    ITALIC: (children, { key }) => <em key={key}>{children}</em>,
    UNDERLINE: (children, { key }) => <u key={key}>{children}</u>,
  },
  blocks: {
    unstyled: (children, { data }) =>
      children.map((child, i) => [<p style={data[i]}>{child}</p>, <br />]),
    'header-one': (children, { data }) =>
      children.map((child, i) => <h1 style={data[i]}>{child}</h1>),
    'header-two': (children, { data }) =>
      children.map((child, i) => <h2 style={data[i]}>{child}</h2>),
    'unordered-list-item': (children, { depth, keys }) => (
      <ul key={keys[keys.length - 1]} className={`ul-level-${depth}`}>
        {children.map(child => <li>{child}</li>)}
      </ul>
    ),
    'ordered-list-item': (children, { depth, keys }) => (
      <ol key={keys.join('|')} className={`ol-level-${depth}`}>
        {children.map((child, index) => <li key={keys[index]}>{child}</li>)}
      </ol>
    ),
  },
  entities: {
    LINK: (children, data, { key }) => (
      <Link key={key} to={data.url}>
        {children}
      </Link>
    ),
  },
};

class DraftRenderer extends React.Component {
  static propTypes = {
    raw: PropTypes.object,
    placeholder: PropTypes.string,
  };
  renderWarning() {
    if (this.props.placeholder) {
      return <div>{this.props.placeholder}</div>;
    }
    return null;
  }

  render() {
    const { raw } = this.props;
    if (!raw) {
      return this.renderWarning();
    }
    const rendered = redraft(raw, renderers);
    if (!rendered) {
      return this.renderWarning();
    }
    const style = { whiteSpace: 'pre-wrap' };
    return <div style={style}>{rendered}</div>;
  }
}

export default DraftRenderer;



// WEBPACK FOOTER //
// src/components/DraftRenderer/DraftRenderer.js